module.exports = __webpack_public_path__ + "static/media/MicrosoftTeams-image (5).ea91815f.png";